import { render, staticRenderFns } from "./ProfileHeaderAvatar.vue?vue&type=template&id=8f3fa768&scoped=true&"
import script from "./ProfileHeaderAvatar.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeaderAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeaderAvatar.vue?vue&type=style&index=0&id=8f3fa768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3fa768",
  null
  
)

export default component.exports